import React from 'react';

interface Props {
	size: number;
}

export const HospitalityIcon: React.FC<Props> = props => (
	<svg
		aria-hidden='true'
		height={props.size}
		viewBox='0 0 24 24'
		width={props.size}
		xmlns='http://www.w3.org/2000/svg'
	>
		<title>hospitality</title>
		<path d='M23.16 20.93H1.31v-.4-.43A10.87 10.87 0 0112.23 9.33a10.87 10.87 0 0111 10.77v.43zm-21-.83h20.19a10 10 0 00-10.12-9.94A10 10 0 002.12 20.1z' />
		<path d='M22.71 22.77H1.29a.91.91 0 01-.91-.91V21a.91.91 0 01.91-.91h21.42a.91.91 0 01.91.91v.82a.91.91 0 01-.91.95zM1.29 21a.08.08 0 00-.08.08v.82a.09.09 0 00.08.08h21.42a.09.09 0 00.08-.08V21a.08.08 0 00-.08-.08zM12.23 10.16a1.59 1.59 0 111.59-1.59 1.59 1.59 0 01-1.59 1.59zm0-2.34a.76.76 0 10.76.75.76.76 0 00-.76-.75zM4.6 17.22h-.08a.41.41 0 01-.32-.49 6.3 6.3 0 011.59-2.78 5.22 5.22 0 012.8-1.44.4.4 0 01.46.36.41.41 0 01-.36.46 4.37 4.37 0 00-2.3 1.19A5.61 5.61 0 005 16.89a.41.41 0 01-.4.33zM11.46 6a.46.46 0 01-.29-.11.42.42 0 010-.59c.6-.64.66-1 .65-1.07a.21.21 0 00-.09-.23c-1-.92-.59-1.83 0-2.61a.42.42 0 01.58-.09.41.41 0 01.1.57c-.64.9-.46 1.17-.09 1.51a1.05 1.05 0 01.36.76 2.5 2.5 0 01-.88 1.67.39.39 0 01-.34.19z' />
		<path d='M12.71 6a.43.43 0 01-.28-.11.41.41 0 010-.59c.6-.64.66-1 .66-1.07A.26.26 0 0013 4c-1-.92-.58-1.83 0-2.61a.43.43 0 01.58-.09.41.41 0 01.1.57c-.64.9-.45 1.17-.08 1.51a1.14 1.14 0 01.36.76A2.55 2.55 0 0113 5.82a.43.43 0 01-.29.18z' />
	</svg>
);
